import React from 'react';
import { useApp } from '../../context/AppContext';
import TourCard from './TourCard';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';

const TourListPage = ({ category, title, description, heroImage }) => {
  const { tours } = useApp();
  const categoryTours = tours.filter(t => t.category === category);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero */}
      <div className="relative h-[40vh] flex items-center">
        <div className="absolute inset-0">
          <img
            src={heroImage || 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1920'}
            alt={title}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/40" />
        </div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">{title}</h1>
          <p className="text-xl text-white/80 max-w-2xl">{description}</p>
        </div>
      </div>

      {/* Tour Grid */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {categoryTours.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categoryTours.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
        ) : (
          <div className="text-center py-16">
            <p className="text-gray-500 text-lg">No tours available in this category yet. Check back soon!</p>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default TourListPage;
